// Panier : suppression d'une configuration, enregistrement des attributs de facturation, contrôle avant paiement.
(() => {
  const root = document.querySelector('[data-adc-cart]');
  if (!root) return;
  const form = root.querySelector('[data-adc-cart-form]');
  const post = (url, body) => fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
  const updateUrl = (window.routes && window.routes.cart_update_url ? window.routes.cart_update_url : '/cart/update') + '.js';

  root.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-adc-remove]');
    if (!btn) return;
    const updates = {};
    btn.dataset.adcRemove.split(',').filter(Boolean).forEach((k) => { updates[k] = 0; });
    btn.disabled = true;
    btn.textContent = 'Suppression…';
    try { await post(updateUrl, { updates }); } finally { window.location.reload(); }
  });

  if (!form) return;
  const fields = Array.from(form.querySelectorAll('[data-adc-attr]'));
  let timer;
  const save = () => {
    const attributes = {};
    fields.forEach((f) => { attributes[f.name.replace(/^attributes\[|\]$/g, '')] = f.value.trim(); });
    return post(updateUrl, { attributes }).catch(() => {});
  };
  fields.forEach((f) => f.addEventListener('input', () => {
    f.removeAttribute('aria-invalid');
    const err = f.closest('.adc-field').querySelector('.adc-error');
    if (err) err.textContent = '';
    clearTimeout(timer);
    timer = setTimeout(save, 600);
  }));

  const fail = (input, msg) => {
    input.setAttribute('aria-invalid', 'true');
    input.closest('.adc-field').querySelector('.adc-error').textContent = msg;
    return input;
  };

  form.addEventListener('submit', (e) => {
    const rs = form.querySelector('[name="attributes[Raison sociale]"]');
    const siret = form.querySelector('[data-adc-siret]');
    const vat = form.querySelector('[data-adc-vat]');
    let first = null;
    siret.value = siret.value.replace(/\s+/g, '');
    vat.value = vat.value.replace(/\s+/g, '').toUpperCase();
    const errors = [];
    if (!rs.value.trim()) errors.push(fail(rs, 'Indiquez la raison sociale de votre entreprise.'));
    if (!/^\d{14}$/.test(siret.value)) errors.push(fail(siret, 'Le SIRET compte 14 chiffres.'));
    if (vat.value && !/^[A-Z]{2}[0-9A-Z]{2,13}$/.test(vat.value)) errors.push(fail(vat, 'Le numéro de TVA commence par deux lettres (FR pour la France), suivies de chiffres.'));
    first = errors[0] || null;
    if (first) {
      e.preventDefault();
      first.focus();
      // Blocage avant paiement : quel champ de facturation manque (jamais sa valeur).
      const key = first === rs ? 'raison_sociale' : (first === siret ? 'siret' : 'tva');
      if (typeof window.adcTrack === 'function') window.adcTrack('paiement_bloque', { champ: key }, key);
      return;
    }
    if (typeof window.adcTrack === 'function') window.adcTrack('paiement_commence', { pieces: Number(root.dataset.count || 0) });
  });
})();
